import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ✅ Get Plans
export async function loadPlansApi() {
  try {
    const fd = new FormData();

    const res = await axios.post(`${apiBaseUrl}planapis/get_plans`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}

// ✅ Create Plan
export async function createPlanApi(payload) {
  try {
    const fd = new FormData();

    fd.append("mplan_id", payload.mplan_id || "");
    fd.append("mplan_name", payload.mplan_name || "");
    fd.append("mplan_code", payload.mplan_code || "");
    fd.append("mplan_status", payload.mplan_status || "");
    fd.append("mplan_price", payload.mplan_price || "");
    fd.append("mplan_duration", payload.mplan_duration || "");

    fd.append("mplan_audience_limit", payload.mplan_audience_limit || "");
    fd.append("mplan_broadcast_limit_daily", payload.mplan_broadcast_limit_daily || "");
    fd.append("mplan_campaign_limit", payload.mplan_campaign_limit || "");

    fd.append("mplan_features", payload.mplan_features || "");

    fd.append("mplan_discovery_boost", payload.mplan_discovery_boost || "");
    fd.append("mplan_priority_support", payload.mplan_priority_support || "");

    fd.append("mplan_created_by", payload.mplan_created_by || "");
    fd.append("mplan_updated_by", payload.mplan_updated_by || "");


    const res = await axios.post(`${apiBaseUrl}planapis/create_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}

// ✅ Update Status
export async function updatePlanStatus(mplan_id, mplan_status) {
  try {
    const fd = new FormData();

    fd.append("mplan_id", mplan_id);
    fd.append("mplan_status", mplan_status);

    const res = await axios.post(`${apiBaseUrl}planapis/update_plan_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}

export async function delPlanApi(mplan_id) {
  try {
    const fd = new FormData();

    fd.append("mplan_id", mplan_id);

    const res = await axios.post(`${apiBaseUrl}planapis/del_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}
